import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=fbdefea2&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=fbdefea2&prod&scoped=true&lang=scss"
import style1 from "./UserInfo.vue?vue&type=style&index=1&id=fbdefea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdefea2",
  null
  
)

export default component.exports